export const maxUploadBytes = 15 * 1000 * 1000;

/** A byte count as German MB text, e.g. `33,2 MB`. */
export function megaBytesText(bytes) {
	return `${(bytes / 1000000).toFixed(1).replace(".", ",")} MB`;
}

/** Shown when the server, not the app, rejected the size. */
export const tooLargeText =
	`Die Datei ist zu groß. Erlaubt sind maximal `
	+ `${megaBytesText(maxUploadBytes)}.`;

/**
 * The error text for a file that is too large to upload, or
 * `undefined` when the file fits. Checked before the upload starts,
 * because the server side rejection is slow and unreadable.
 */
export function uploadSizeError(file) {
	if (!file || typeof file.size !== "number") return undefined;
	if (file.size <= maxUploadBytes) return undefined;
	return `Die Datei ist mit ${megaBytesText(file.size)} zu groß. `
		+ `Erlaubt sind maximal ${megaBytesText(maxUploadBytes)}.`;
}

/**
 * Whether a save rejection is the server refusing an oversized body.
 */
export function isTooLargeError(error) {
	if (!error) return false;
	const text = `${error.message || ""} ${error.responseText || ""}`
		.toLowerCase();
	return text.includes("too large") || text.includes("413");
}
